import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import Menu from "./Components/Menu/menu";
import Body from "./Components/Body/body";
import Footer from "./Components/Footer/footer";
import Alumno from "./Components/Alumno/alumno";
import "./index.css";
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"
//import ReactGA from "react-ga4";

//const TRACKING_ID = "G-D15KPZ8WYE";
//ReactGA.initialize(TRACKING_ID);
//ReactGA.send("/start")

ReactDOM.render(
  <BrowserRouter>
    <Menu />
    <Body />
    <Alumno />
    <Footer />
  </BrowserRouter>,
  document.getElementById("root")
);
